import type { RoleDto } from '@lagerfeuer/shared';

/**
 * Neue Rollenpositionen nach dem Verschieben von `movingId` an Index `toIndex` (Liste absteigend nach Position,
 * ohne @everyone). Verschiebbare Rollen tauschen nur ihre bisherigen Positions-Slots untereinander – Rollen
 * oberhalb der eigenen höchsten Rolle (nicht in `editable`) behalten ihre Position. Liefert nur Änderungen.
 */
export function reorderRoles(orderedDesc: RoleDto[], editable: ReadonlySet<string>, movingId: string, toIndex: number): { id: string; position: number }[] {
  if (!editable.has(movingId)) return [];
  const from = orderedDesc.findIndex((r) => r.id === movingId);
  if (from < 0) return [];
  const list = [...orderedDesc];
  const [moving] = list.splice(from, 1);
  list.splice(Math.max(0, Math.min(toIndex, list.length)), 0, moving!);
  const slots = orderedDesc.filter((r) => editable.has(r.id)).map((r) => r.position).sort((a, b) => b - a);
  const reordered = list.filter((r) => editable.has(r.id));
  const changes: { id: string; position: number }[] = [];
  reordered.forEach((r, i) => {
    const position = slots[i]!;
    if (position !== r.position) changes.push({ id: r.id, position });
  });
  return changes;
}

/** Index, an den eine Rolle per Tastatur (eins hoch/runter) wandern darf, oder null wenn blockiert. */
export function neighbourIndex(orderedDesc: RoleDto[], editable: ReadonlySet<string>, id: string, dir: -1 | 1): number | null {
  const i = orderedDesc.findIndex((r) => r.id === id);
  const j = i + dir;
  if (i < 0 || j < 0 || j >= orderedDesc.length) return null;
  if (!editable.has(orderedDesc[j]!.id)) return null;
  return j;
}
